<template>
    <div class="alaka_page">
        <div class="textColumn">
            <h1>ALAKÁ</h1>
            <h2>SAPHIRA, PRESENTES DE AXÉ</h2>
            <p>O Alaká é uma loja dentro do nosso templo que visa auxiliar na compra de velas, paramentos e roupas.</p>
            <p>Além de materiais ritualisticos, também é possível encontrar cristais e demais artigos.</p>
            <p>Toda renda é revertida para manutenção do templo.</p>
        </div>
        <div class="imgcontrol"><imageSelector /></div>
    </div>
</template>

<script>
import ImageSelector from './ImageSelector.vue';
export default {    
    name: 'AlakaPage',
    components: {
        ImageSelector
    },
    mounted() {
        console.log('AlakaPage component mounted');
    }
};
</script>

<style scoped>
@media (max-width: 922px) {
    .alaka_page {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100%;
        padding-left: 10px;
        margin-top: 6vh;
    }
    h1 {
        font-size: 2em;
        margin-bottom: 0.1em;
        font-family: 'Abhaya Libre_Bold', serif;
        font-weight: bold;
    }
    h2 {
        margin-top: -0.6em;
        font-family: 'Abhaya Libre_Bold', serif;
        letter-spacing: 0.1em;
        font-size: 1em;
    }
    p {
        font-family: 'Amiri', serif;
        font-size: 1.2em;
        line-height: 1.0em;
        margin-top: 0.5em;
    }
    .textColumn {
        width: 100%;
        height: auto;
        display: flex;
        justify-content:center;
        align-items:center;
        top:6vh;
        padding-top: 20px;
        padding-left:10px;
        padding-right: 20px;
        flex-direction: column;
    }
    .imgcontrol {
        display: flex;
        justify-content:center;
        align-items:center;
    }
}
@media (min-width: 922px) {
    .alaka_page {
        display: flex;
        justify-content: center;
        align-items: flex-start; /* Alinhamento para o topo */
        flex-direction: row;
        height: 100%;
        padding: 20px 10px 20px 20px;
        box-sizing: border-box;
    }
    .textColumn {
        width: 40%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding-right: 20px;
        flex-direction: column;
    }
    .imgcontrol {
        flex-grow: 1;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: nowrap; /* Impede que o contêiner de imagem quebre de linha */
    }
    h1 {
        font-size: 2.5em;
        margin-bottom: 0.1em;
        font-family: 'Abhaya Libre_Bold', serif;
        font-weight: bold;
    }
    h2 {
        margin-top: -0.6em;
        font-family: 'Abhaya Libre_Bold', serif;
        letter-spacing: 0.1em;
        font-size: 1em;
    }
    p {
        font-family: 'Amiri', serif;
        font-size: 1.2em;
        line-height: 1.0em;
        margin-top: 0.5em;
    }
}
</style>